import { LoginContextType } from '@/hooks/useLogin';
import { LoginSignupFlowInitiatedFrom } from '@/types/analytics';
import { modalConstants } from '../constants';
import { ReviewsModalType } from '@/types/modal';

function hideModal() {
  window.location.hash = '';
  return { type: modalConstants.HIDE, data: {} };
}

function login(
  props:
    | {
        show: true;
        loginContext: LoginContextType;
        initiatedFrom: LoginSignupFlowInitiatedFrom;
      }
    | {
        show: false;
      },
) {
  if (props.show) {
    props.loginContext.onOpen(props.initiatedFrom);
  }

  return { type: modalConstants.LOGIN, data: { show: props.show } };
}

function userProfileOnboarding({ show }: { show: boolean }) {
  return { type: modalConstants.USER_PROFILE_ONBOARDING, data: { show } };
}

function userLocationOnboarding({ show }: { show: boolean }) {
  return { type: modalConstants.USER_LOCATION_ONBOARDING, data: { show } };
}

function nps({ show }: { show: boolean }) {
  return { type: modalConstants.NPS, data: { show } };
}

function lastMinute({ show }: { show: boolean }) {
  return { type: modalConstants.LAST_MINUTE, data: { show } };
}

function reviews(args: ReviewsModalType) {
  return { type: modalConstants.REVIEWS, payload: { ...args } };
}

function addReviewsPrevState(args: ReviewsModalType) {
  return { type: modalConstants.ADD_REVIEWS_PREV_STATE, payload: { ...args } };
}

function removeReviewsPrevState(id: number) {
  return { type: modalConstants.REMOVE_REVIEWS_PREV_STATE, payload: { id } };
}

function resetReviewsPrevState() {
  return { type: modalConstants.RESET_REVIEWS_PREV_STATE };
}

function redirect(type: string, url: string) {
  function red(url: string) {
    return { type: modalConstants.REDIRECT, data: url };
  }

  return (dispatch: (action: { type: string; data: any }) => void) => {
    dispatch(red(url));
    setTimeout(() => {
      dispatch(hideModal());
    }, 100);
  };
}

export const modalActions = {
  redirect,
  hideModal,
  login,
  userProfileOnboarding,
  userLocationOnboarding,
  nps,
  reviews,
  lastMinute,
  addReviewsPrevState,
  removeReviewsPrevState,
  resetReviewsPrevState,
};
